import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import EndCallButton from '../Buttons/EndCallButton/EndCallButton';
import Menu from './Menu/Menu';
import useParticipants from '../../hooks/useParticipants/useParticipants';
import useRoomState from '../../hooks/useRoomState/useRoomState';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import { Typography, Grid, Hidden, Box } from '@material-ui/core';
import RoomToggleAudioButton from '../Buttons/ToggleAudioButton/RoomToggleAudioButton';
import RoomToggleVideoButton from '../Buttons/ToggleVideoButton/RoomToggleVideoButton';
import ScreenShotButton from '../Buttons/ScreenShotButton/ScreenShotButton';
import { useAppState } from '../../state';
import RecordButton from '../Buttons/RecordButton/RecordButton';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      backgroundColor: theme.palette.background.default,
      bottom: 0,
      left: 0,
      right: 0,
      height: `${theme.footerHeight}px`,
      position: 'fixed',
      display: 'flex',
      zIndex: 10,
      [theme.breakpoints.down('sm')]: {
        height: `${theme.mobileFooterHeight}px`,
        padding: 0,
      },
    },
    screenShareBanner: {
      position: 'fixed',
      zIndex: 8,
      bottom: `${theme.footerHeight}px`,
      left: 0,
      right: 0,
      height: '104px',
      background: 'rgba(0, 0, 0, 0.5)',
      '& h6': {
        color: 'white',
      },
      '& button': {
        background: 'white',
        color: theme.brand,
        border: `2px solid ${theme.brand}`,
        margin: '0 2em',
        '&:hover': {
          color: '#600101',
          border: `2px solid #600101`,
          background: '#FFE9E7',
        },
      },
    },
    hideMobile: {
      display: 'initial',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
  })
);

export default function MenuBar() {
  const classes = useStyles();
  const roomState = useRoomState();
  const isReconnecting = roomState === 'reconnecting';
  const { room } = useVideoContext();
  const participants = useParticipants();

  const { role } = useAppState();

  return (
    <>
      <footer className={classes.container}>
        <Box px={2} py={0.5} width="100%" height="100%" display="flex" alignItems="center">
          <Grid container justifyContent="space-around" alignItems="center">
            <Hidden smDown>
              <Grid style={{ flex: 1 }}>
                <Typography variant="body1">
                  {room!.name} | {participants.length + 1} participant{participants.length ? 's' : ''}
                </Typography>
              </Grid>
            </Hidden>
            <Grid item>
              <Box display="flex" alignItems="center" gridGap={12}>
                <RoomToggleAudioButton disabled={isReconnecting} />
                <RoomToggleVideoButton disabled={isReconnecting} />
                {role === 'coordinator' && <ScreenShotButton disabled={isReconnecting} />}
                <RecordButton disabled={isReconnecting} />
                <Menu />
              </Box>
            </Grid>
            <Grid style={{ flex: 1 }}>
              <Grid container justifyContent="flex-end">
                <EndCallButton />
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </footer>
    </>
  );
}
